import '../styles/NomDirAdm.css';

function NomDirAdm() {
    return (
        <h2 className='nom-dir-adm'>Dirección Ejecutiva de Control de Bienes y Servicios</h2>
    )

}

export default NomDirAdm;